import { FC } from 'react';

type Props = {
  size?: number,
  className?: string,
};

// Stroke-based chevron pointing right; inherits the parent's text colour via
// currentColor. Rotate it with CSS at the call site (e.g. an expand caret).
const ChevronRightOutlineIcon: FC<Props> = ({ size = 14, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 6l6 6-6 6"></path>
  </svg>
);

export default ChevronRightOutlineIcon;
